/**
 * Initialisation Sentry (monitoring erreurs frontend).
 *
 * ETAT : prepare en Phase 0, NON ACTIF tant que @sentry/react n'est pas
 * installe. Mirror du pattern Playwright (setup present, activation = une
 * decision consciente pour ne pas alourdir le bundle ni le lockfile).
 *
 * ACTIVATION (quand on veut le monitoring en prod) :
 *   1. npm install @sentry/react
 *   2. Decommenter le bloc "IMPLEMENTATION REELLE" + supprimer le no-op
 *   3. Poser REACT_APP_SENTRY_DSN dans Vercel (Environment Variables)
 *
 * En l'absence de REACT_APP_SENTRY_DSN, initSentry() ne fait rien :
 * sans danger en dev local et en preview.
 */

const DSN = process.env.REACT_APP_SENTRY_DSN;
// eslint-disable-next-line no-unused-vars
const ENVIRONMENT = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

export function initSentry() {
  // --- NO-OP (etat actuel : @sentry/react non installe) ---
  if (!DSN) return;
  // DSN pose mais package absent : on log un avis, pas de crash.
  // Supprimer ce bloc apres activation.
  // eslint-disable-next-line no-console
  console.info(
    '[sentry] REACT_APP_SENTRY_DSN defini mais @sentry/react non installe. ' +
      'Lancer `npm install @sentry/react` puis activer src/observability/sentry.js.'
  );

  /* --- IMPLEMENTATION REELLE (decommenter apres npm install @sentry/react) ---
  import * as Sentry from '@sentry/react';

  Sentry.init({
    dsn: DSN,
    environment: ENVIRONMENT,
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.1),
    sendDefaultPii: false,           // RGPD : pas de PII par defaut
    enabled: ENVIRONMENT !== 'development',
  });
  --- fin implementation reelle --- */
}

export default initSentry;
